export default class GeoLocation {
    watcherId = null
    constructor() {
        this.watcherId = null
    }

    watch(cb, errorCb, options) {
        if (this.watcherId) {
            return
        }
        if (!navigator.geolocation) {
            return errorCb("not_supported")
        }
        if (options === undefined) {
            options = {}
        }
        const defaultOptions = {
            enableHighAccuracy: true,
            timeout: 20000,
            maximumAge: 1000,
        }

        this.watcherId = navigator.geolocation.watchPosition(
            cb,
            error => {
                if (GeolocationPositionError.PERMISSION_DENIED == error.code) {
                    errorCb("location_permission_denied")
                } else if (GeolocationPositionError.POSITION_UNAVAILABLE == error.code) {
                    errorCb("position_unavailable")
                }
            },
            Object.assign(defaultOptions, options)
        )
    }

    stopWatch() {
        if (this.watcherId) {
            navigator.geolocation.clearWatch(this.watcherId)
            this.watcherId = null
        }
    }

    static getCurrentPosition(options) {
        return new Promise((resolve, reject) => {
            const defaultOptions = {
                enableHighAccuracy: true,
                timeout: 20000,
                maximumAge: 1000,
            }
            navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
                Object.assign(defaultOptions, options)
            )
        })
    }

    getDeviceOrientation(cb, cbError) {
        if (window.DeviceOrientationEvent) {
            // Listen for the deviceorientation event and handle the raw data
            window.addEventListener("deviceorientation", function(e) {
                let compassdir

                compassdir = e.alpha
                cb(compassdir)(
                    document.querySelector('img[src="/img/myposition.png"]')
                ).style.transform = "rotate(" + Math.round(compassdir) + "deg)"
            })
        }
    }

    static getDistance(p1, p2) {
        const rad = function(x) {
            return (x * Math.PI) / 180
        }
        const R = 6378137 // Earth’s mean radius in meter
        const dLat = rad(p2.lat - p1.lat)
        const dLong = rad(p2.lng - p1.lng)
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(p1.lat)) *
                Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) *
                Math.sin(dLong / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        const d = R * c
        return d
    }
}
